import { lazy } from 'react';
const CustomHomeRubatec = lazy(() => import('./CustomHomeRubatec'));
export default CustomHomeRubatec;
